﻿import controller from '../../../../Resources/Scripts/_Shared/controller';

function startpageerrormessage(context) {
  const dismissButton = context.querySelector('.aimo-error-message__dismiss');

  function init() {

    context.classList.add('aimo-error-message--visible');
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('StatusMessage')) {
      urlParams.delete('StatusMessage'); 
      const urlParamsText = urlParams.toString() ? '?' + urlParams.toString() : '';
      window.history.replaceState({}, document.title, window.location.pathname + urlParamsText);
    }
    dismissButton.addEventListener('click', function(e) {
      e.preventDefault();
      if (!document.querySelector('.aimo-service-information--visible')) {
        context.style.marginTop = `-${context.offsetHeight}px`;
        setTimeout(() => {
          context.remove();
        }, 500);
      }
      else context.remove();
    });
  }

  return {
    init
  };
}

controller.add('startpage-errormessage', startpageerrormessage);